import { Reveal } from "./Reveal";
import { Chapter } from "./Chapter";
import { useContent } from "@/lib/content";

const STAGE_IMAGE =
  "https://images.unsplash.com/photo-1562329265-95a6d7a83440?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHx0aGVhdHJlJTIwc3RhZ2UlMjBkcmFtYXRpYyUyMGxpZ2h0aW5nfGVufDB8fHx8MTc4NzQzNzcyNnww&ixlib=rb-4.1.0&q=85";

export const Training = () => {
  const { training, chapters } = useContent();
  return (
  <section className="relative overflow-hidden" data-testid="training-section">
    <div aria-hidden="true" className="absolute inset-0">
      <img src={STAGE_IMAGE} alt="" className="h-full w-full object-cover opacity-[0.08]" />
    </div>
    <div className="relative mx-auto max-w-7xl px-6 md:px-12 py-32 md:py-44">
      <Chapter number="03" kicker={chapters.training.kicker} title={chapters.training.title} id="training" />
      <div className="mt-20 grid md:grid-cols-2 gap-x-16 gap-y-12">
        {training.map((t, i) => (
          <Reveal key={`${t.title}-${i}`} delay={(i % 2) * 0.1}>
            <div className="group border-b border-champagne pb-8" data-testid={`training-item-${i}`}>
              <h3 className="font-serif text-2xl md:text-3xl font-medium text-burgundy">
                {t.title}
              </h3>
              <p className="mt-2 text-[11px] font-semibold uppercase tracking-[0.25em] text-rose">{t.org}</p>
              <p className="mt-3 text-sm md:text-base leading-relaxed text-charcoal/70">{t.detail}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
